export default "__VITE_ASSET__CI6OK4vQ__"